class CompareProduct {
  constructor() {
    this.storageKey = 'm-compare-products'
    this.compareModeKey = 'koni-compare-mode-active'
    this.products = []
    this.productNodes = {}
    this.productCache = {}

    this.pageTemplate = 'page.product-compare'
    this.addedClass = 'added-to-compare'
    this.maxProducts = (window.MinimogSettings && window.MinimogSettings.compareMaxProducts) || 6
    this.minProducts = (window.MinimogSettings && window.MinimogSettings.compareMinProducts) || 2
    this.selectors = {
      container: '.m-compare-page-content__wrapper',
      noProducts: '.m-compare-no-products',
      wrapper: '.m-compare-card',
      item: '.m-product-card',
      compareButton: '.m-compare-button',
      compareText: '.m-compare-button-text',
      removeButton: '.m-compare-remove-button',
      count: '.m-compare-count',
      bar: '[data-koni-compare-bar]',
      barSlots: '[data-koni-compare-bar-slots]',
      barStatus: '[data-koni-compare-bar-status]',
      modal: '[data-koni-compare-modal]',
      minModal: '[data-koni-compare-min-modal]'
    }
    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])));
    if (this.products.length > this.maxProducts) {
      this.products = this.products.slice(0, this.maxProducts)
      this.saveToStorage()
    }
    this.isComparePage = MinimogSettings.template === this.pageTemplate;
    this._modalInstance = null
    // Mode is session-only: always off on load; user must turn Compare on.
    this._compareModeActive = false
    try {
      localStorage.removeItem(this.compareModeKey)
    } catch (e) {}
    this.init()
  }

  init = () => {
    if (this.isComparePage) {
      this.renderComparePage();
      this.addEventToRemoveButtons();
    }
    this.setCompareButtonsState();
    this.addEventToCompareButtons();
    this.updateCompareCount();
    this.initComparePopup();
  }

  isCompareMode = () => {
    return !!this._compareModeActive
  }

  setCompareMode = (active, silent = false) => {
    this._compareModeActive = !!active
    document.body.classList.toggle('koni-compare-mode', active)

    const toggle = document.querySelector('[data-koni-compare-mode-toggle]')
    if (toggle) {
      toggle.checked = active
    }

    if (active) {
      this.updateCompareBar()
      return
    }

    this.hideCompareBar()
  }

  ensureCompareMode = () => {
    if (document.querySelector('[data-koni-compare-mode-toggle]') && !this.isCompareMode()) {
      this.setCompareMode(true, true)
    }
  }

  updateCompareBarSubmitState = () => {
    const submit = document.querySelector('[data-koni-compare-open]')
    if (!submit) return
    const canCompare = this.products.length >= this.minProducts
    submit.disabled = !canCompare
    submit.classList.toggle('is-disabled', !canCompare)
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }

  isAtLimit = () => {
    return this.products.length >= this.maxProducts
  }

  getMinProducts = () => {
    return this.minProducts
  }

  showLimitMessage = () => {
    const message = (window.MinimogStrings && window.MinimogStrings.compareLimitReached) ||
      `You can compare up to ${this.maxProducts} products. Remove one to add another.`

    let toast = document.querySelector('[data-koni-compare-limit-toast]')
    if (!toast) {
      toast = document.createElement('div')
      toast.className = 'koni-compare-limit-toast'
      toast.setAttribute('data-koni-compare-limit-toast', '')
      document.body.appendChild(toast)
    }

    toast.textContent = message
    toast.classList.add('is-visible')
    clearTimeout(this._limitToastTimer)
    this._limitToastTimer = setTimeout(() => {
      toast.classList.remove('is-visible')
    }, 3500)
  }

  parseProductPayload = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const node = doc.querySelector('[data-koni-compare-product]')
    if (!node) return null
    try {
      return JSON.parse(node.textContent)
    } catch (error) {
      return null
    }
  }

  escapeHtml = (str) => {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  }

  fetchProductData = async (handle) => {
    if (this.productCache[handle]) {
      return this.productCache[handle]
    }
    const html = await fetchCache(`/products/${handle}?view=compare`)
    const data = this.parseProductPayload(html)
    if (data) {
      this.productCache[handle] = data
    }
    return data
  }

  addToCompare(handle) {
    if (!handle || this.products.indexOf(handle) !== -1) {
      return false
    }
    if (this.isAtLimit()) {
      this.showLimitMessage()
      return false
    }
    this.products.push(handle)
    this.saveToStorage()
    return true
  }

  removeFromCompare(handle) {
    this.products = this.products.filter(hdl => hdl !== handle)
    delete this.productCache[handle]
    this.saveToStorage()
  }

  clearAllCompare = () => {
    this.products = []
    this.productCache = {}
    this.saveToStorage()
    this.setCompareButtonsState()
    this.updateCompareCount()
    this.updateCompareBar()
    this.closeCompareModal()
  }

  setCompareButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.compareButton)
    buttons.forEach(btn => {
      const prodHandle = btn && btn.dataset.productHandle
      if (!prodHandle) return
      const isAdded = this.products.indexOf(prodHandle) >= 0
      btn.classList.toggle(this.addedClass, isAdded)
      const compareText = btn.querySelector(this.selectors.compareText)
      if (!compareText) return
      const addLabel = (window.MinimogStrings && window.MinimogStrings.addToCompare) || 'Compare'
      const removeLabel = (window.MinimogStrings && window.MinimogStrings.removeCompare) || 'Remove'
      compareText.textContent = isAdded ? removeLabel : addLabel
      compareText.dataset.revertText = isAdded ? addLabel : removeLabel
    })
  }

  updateCompareCount = () => {
    const size = this.products.length
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach(elem => {
      elem.textContent = size
      if (size < 1) {
        elem.classList.add('m:hidden')
      } else {
        elem.classList.remove('m:hidden')
      }
    })
  }

  getCompareStatusLabel = () => {
    const title = (window.MinimogStrings && window.MinimogStrings.compareTitle) || 'Compare'
    return `${title} (${this.products.length}/${this.maxProducts})`
  }

  showCompareBar = () => {
    const bar = document.querySelector(this.selectors.bar)
    if (!bar) return
    bar.hidden = false
    document.body.classList.add('koni-compare-bar-active')
    requestAnimationFrame(() => {
      bar.classList.add('is-visible')
    })
  }

  hideCompareBar = () => {
    const bar = document.querySelector(this.selectors.bar)
    if (!bar) return
    bar.classList.remove('is-visible')
    document.body.classList.remove('koni-compare-bar-active')
    setTimeout(() => {
      if (!this.isCompareMode() && !this.products.length) {
        bar.hidden = true
      }
    }, 300)
  }

  updateCompareBar = async () => {
    const bar = document.querySelector(this.selectors.bar)
    const slots = document.querySelector(this.selectors.barSlots)
    const status = document.querySelector(this.selectors.barStatus)
    if (!bar || !slots) return

    const shouldShowBar = this.isCompareMode()

    if (!shouldShowBar) {
      this.hideCompareBar()
      slots.innerHTML = ''
      if (status) status.textContent = this.getCompareStatusLabel()
      this.updateCompareBarSubmitState()
      return
    }

    const products = this.products.length
      ? await Promise.all(this.products.map((handle) => this.fetchProductData(handle)))
      : []

    let html = ''

    for (let i = 0; i < this.maxProducts; i++) {
      const product = products[i]
      if (product) {
        html += `<div class="koni-compare-bar__slot" data-compare-slot="${this.escapeHtml(product.handle)}">`
        if (product.image) {
          html += `<img src="${this.escapeHtml(product.image)}" alt="${this.escapeHtml(product.title || '')}" loading="lazy" width="56" height="56">`
        }
        html += `<button type="button" class="koni-compare-bar__slot-remove" data-koni-compare-bar-remove data-product-handle="${this.escapeHtml(product.handle)}" aria-label="Remove">`
        html += '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M1 1l6 6M7 1L1 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>'
        html += '</button></div>'
      } else {
        html += '<div class="koni-compare-bar__slot koni-compare-bar__slot--empty" aria-hidden="true"></div>'
      }
    }

    slots.innerHTML = html
    if (status) status.textContent = this.getCompareStatusLabel()
    this.showCompareBar()
    this.updateCompareBarSubmitState()
  }

  getModalInstance = () => {
    if (!this._modalInstance && window.MinimogTheme && window.MinimogTheme.KoniCompare) {
      this._modalInstance = window.MinimogTheme.KoniCompare.initModal(this)
    }
    return this._modalInstance
  }

  showMinProductsModal = () => {
    const modal = document.querySelector(this.selectors.minModal)
    if (!modal) return
    modal.hidden = false
    document.body.classList.add('koni-compare-modal-open')
  }

  closeMinProductsModal = () => {
    const modal = document.querySelector(this.selectors.minModal)
    if (!modal) return
    modal.hidden = true
    if (!document.querySelector(`${this.selectors.modal}:not([hidden])`)) {
      document.body.classList.remove('koni-compare-modal-open')
    }
  }

  openCompareModal = async () => {
    if (this.products.length < this.minProducts) {
      this.showMinProductsModal()
      return
    }

    const modal = document.querySelector(this.selectors.modal)
    if (!modal) return

    modal.hidden = false
    document.body.classList.add('koni-compare-modal-open')

    const instance = this.getModalInstance()
    if (instance) {
      await instance.render()
    }
  }

  closeCompareModal = () => {
    const modal = document.querySelector(this.selectors.modal)
    if (!modal) return
    modal.hidden = true
    if (!document.querySelector(`${this.selectors.minModal}:not([hidden])`)) {
      document.body.classList.remove('koni-compare-modal-open')
    }
  }

  initComparePopup = () => {
    const bar = document.querySelector(this.selectors.bar)
    if (!bar) return

    // Keep Compare off until the user enables the toggle (or ensureCompareMode).
    this.setCompareMode(false, true)

    addEventDelegate({
      selector: '[data-koni-compare-mode-toggle]',
      handler: (e, input) => {
        this.setCompareMode(!!input.checked)
      }
    })

    addEventDelegate({
      selector: '[data-koni-compare-bar-remove]',
      handler: (e, btn) => {
        e.preventDefault()
        const handle = btn && btn.dataset.productHandle
        if (!handle) return
        this.removeFromCompare(handle)
        this.setCompareButtonsState()
        this.updateCompareCount()
        this.updateCompareBar()
        const modal = document.querySelector(this.selectors.modal)
        const instance = this.getModalInstance()
        if (instance && modal && !modal.hidden) {
          if (this.products.length) {
            instance.render()
          } else {
            this.closeCompareModal()
          }
        }
      }
    })

    addEventDelegate({
      selector: '[data-koni-compare-open]',
      handler: (e) => {
        e.preventDefault()
        this.openCompareModal()
      }
    })

    addEventDelegate({
      selector: '[data-koni-compare-clear]',
      handler: (e) => {
        e.preventDefault()
        this.clearAllCompare()
      }
    })

    addEventDelegate({
      selector: '[data-koni-compare-modal-close]',
      handler: (e) => {
        e.preventDefault()
        this.closeCompareModal()
      }
    })

    addEventDelegate({
      selector: '[data-koni-compare-min-close]',
      handler: (e) => {
        e.preventDefault()
        this.closeMinProductsModal()
      }
    })

    addEventDelegate({
      selector: '.m-header__compare',
      handler: (e, link) => {
        e.preventDefault()
        if (!this.products.length) return
        if (this.products.length >= this.minProducts) {
          this.openCompareModal()
        } else {
          this.showCompareBar()
          this.showMinProductsModal()
        }
      }
    })

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return
      this.closeCompareModal()
      this.closeMinProductsModal()
    })
  }

  addEventToCompareButtons = () => {
    addEventDelegate({
      selector: this.selectors.compareButton,
      handler: (e, btn) => {
        e.preventDefault()
        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          const active = !btn.classList.contains(this.addedClass)
          const changed = this.toggleButtonState(btn, active)
          if (!changed) return
          this.ensureCompareMode()
          this.updateCompareCount()
          this.updateCompareBar()
          document.querySelectorAll(this.selectors.compareButton).forEach(btnItem => {
            if (btnItem && btnItem.dataset.productHandle === productHandle && btnItem !== btn) {
              const isAdded = !btnItem.classList.contains(this.addedClass)
              this.toggleButtonState(btnItem, isAdded, true)
            }
          })
        }
      }
    })
  }

  toggleButtonState = (btn, active, silent = false) => {
    const productHandle = btn && btn.dataset.productHandle
    const compareText = btn && btn.querySelector(this.selectors.compareText)

    if (active) {
      if (this.products.indexOf(productHandle) === -1) {
        const added = this.addToCompare(productHandle)
        if (!added) {
          if (!silent) this.showLimitMessage()
          return false
        }
      }
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromCompare(productHandle)
      btn.classList.remove(this.addedClass)
    }

    if (compareText) {
      const revertText = compareText.dataset.revertText
      if (revertText) {
        const temp = compareText.textContent
        compareText.textContent = revertText
        compareText.dataset.revertText = temp
      } else {
        const removeLabel = (window.MinimogStrings && window.MinimogStrings.removeCompare) || 'Remove'
        const addLabel = (window.MinimogStrings && window.MinimogStrings.addToCompare) || 'Compare'
        compareText.textContent = active ? removeLabel : addLabel
      }
    }

    return true
  }

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault()
        const prod = btn && btn.closest(this.selectors.wrapper)
        prod && prod.remove()

        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          this.removeFromCompare(productHandle)
          this.updateCompareCount()
          this.updateCompareBar()
          if (!this.products.length) {
            this.showNoProductsMessage()
          }
        }
      }
    })
  }

  renderComparePage = async () => {
    if (document.querySelector('.koni-compare-page')) {
      var startKoniCompare = () => {
        if (window.MinimogTheme.KoniCompare) {
          window.MinimogTheme._koniCompareInstance = window.MinimogTheme.KoniCompare.initPage(this)
        }
      }
      startKoniCompare()
      if (!window.MinimogTheme._koniCompareInstance) {
        requestAnimationFrame(startKoniCompare)
      }
      return
    }

    const container = document.querySelector(this.selectors.container)
    if (container) {
      let noItemAvailable = true

      if (this.products.length) {
        const promises = this.products.map(async hdl => {
          const prodHTML = await fetchCache(`/products/${hdl}?view=compare`)
          const item = document.createElement("DIV");
          item.classList.add("m:hidden", "m-product-item", "m:w-full", "m-compare-card");
          item.innerHTML = prodHTML
          if (item.querySelector(this.selectors.item)) {
            noItemAvailable = false
            this.productNodes[hdl] = item
          }
        })

        await Promise.all(promises)

        this.products.forEach(hdl => {
          const prodNode = this.productNodes[hdl]
          if (prodNode) {
            container.appendChild(prodNode)
            prodNode.classList.remove('m:hidden')
          }
        })
      }

      if (noItemAvailable) {
        this.showNoProductsMessage()
      }

      container.classList.add('is-visible')
    }
  }

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container)
    const noProducts = document.querySelector(this.selectors.noProducts)

    container.classList.add('m:hidden')
    noProducts.classList.remove('m:hidden')
  }
}

MinimogTheme.CompareProduct = new CompareProduct()
